<template>
  <div class="LLFileModalVideo">
    <video
      v-if="src"
      playsinline
      draggable="false"
      :src="src"
      :poster="poster"
      controls
      class="LLFileModalVideo__video"
    ></video>
  </div>
</template>

<script>
export default {
  name: 'LLFileModalVideo',
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      objectUrl: null
    }
  },
  computed: {
    isTemporary() {
      return !!this.file?.temporary || !!this.file?.isTemporary
    },
    poster() {
      return this.file?.thumbnails?.find((thumbnail) => thumbnail.size === 250)?.location
    },
    src() {
      return this.isTemporary ? this.objectUrl : this.file && this.file.location
    }
  },
  watch: {
    file: {
      handler() {
        this.resetSrc()
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.revokeObjectUrl()
  },
  methods: {
    revokeObjectUrl() {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl)
        this.objectUrl = null
      }
    },
    resetSrc() {
      this.revokeObjectUrl()
      if (this.isTemporary && this.file?.temporaryData?.browserFile) {
        this.objectUrl = URL.createObjectURL(this.file.temporaryData.browserFile)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.LLFileModalVideo {
  @apply w-full h-full flex items-center justify-center;
  user-select: text;

  &__video {
    @apply w-full h-full object-contain select-none;
    background-color: #000000;
  }
}
</style>
